// Module
var code = `<template>
  <require from="./mdc-daterange-dialog.scss"></require>
  <require from="./date-converter"></require>

  <mdc-dialog view-model.ref="dialog" class="mdc-daterange-dialog">
    <div class="mdc-daterange-dialog__container">
      <div class="mdc-daterange-dialog__header">
        <mdc-list mdclist:action.trigger="handleMenuSelected(\$event.detail.data)">
          <mdc-list-item repeat.for="pi of predefinedIntervals" value.bind="pi">\${pi.label}</mdc-list-item>
        </mdc-list>
      </div>
      <div class="mdc-daterange-dialog__content">
        <div class="mdc-daterange-dialog__panels">
          <div class="mdc-daterange-dialog__from-panel">
            <div class="mdc-daterange-dialog__nav">
              <button mdc-icon-button icon="keyboard_arrow_left" click.trigger="prevFrom()" disabled.bind="canGoPrevFrom"></button>
              <mdc-select value.bind="fromMonth" fixed class="mdc-daterange-dialog__month" mdcselect:change.trigger="buildFromDays()" outlined.bind="false" natural-width>
                <mdc-list>
                  <mdc-list-item repeat.for="m of months" value.bind="\$index" disabled.bind="m.disabled">\${m.name}
                  </mdc-list-item>
                </mdc-list>
              </mdc-select>
              <span class="mdc-daterange-dialog__nav__spacer"></span>
              <mdc-select value.bind="fromYear" fixed class="mdc-daterange-dialog__year" mdcselect:change.trigger="buildFromDays()" outlined.bind="false" natural-width>
                <mdc-list>
                  <mdc-list-item repeat.for="y of years" value.bind="y">\${y}</mdc-list-item>
                </mdc-list>
              </mdc-select>
              <button mdc-icon-button icon="keyboard_arrow_right" click.trigger="nextFrom()" disabled.bind="canGoNextFrom"></button>
            </div>
            <div class="mdc-daterange-dialog__view">
              <span repeat.for="wd of weekDays" class="mdc-daterange-dialog__week-day">\${wd[0]}</span>
              <div repeat.for="d of fromDays" class="mdc-daterange-dialog__day \${d.selectedFrom ? 'mdc-daterange-dialog__day--selected-from' : ''} \${d.selectedTo ? 'mdc-daterange-dialog__day--selected-to' : ''} \${d.inRange ? 'mdc-daterange-dialog__day--in-range' : ''} \${d.hovered ? 'mdc-daterange-dialog__day--hovered' : ''} \${d.disabled ? 'mdc-daterange-dialog__day--disabled' : ''}" mouseleave.trigger="handleMouseLeave()">
                <a href="#" mdc-ripple="unbounded.bind: true" click.trigger="select(d)" if.bind="d.date && !d.disabled" mouseover.trigger="handleMouseover(d)">
                  <span>\${d.date | date:'d'}</span>
                </a>
                <a if.bind="d.date && d.disabled">
                  <span>\${d.date | date:'d'}</span>
                </a>
                <div class="mdc-daterange-dialog__in-range-indicator mdc-daterange-dialog__in-range-indicator--\${d.selectedFrom ? 'from' : ''}\${d.selectedTo ? 'to' : ''}">
                </div>
                <svg class="mdc-daterange-dialog__hover-border">
                  <line x1="0" y1="10%" x2="100%" y2="10%"></line>
                  <line x1="0" y1="90%" x2="100%" y2="90%"></line>
                </svg>
              </div>
            </div>
          </div>
          <div class="mdc-daterange-dialog__to-panel">
            <div class="mdc-daterange-dialog__nav">
              <button mdc-icon-button icon="keyboard_arrow_left" click.trigger="prevTo()" disabled.bind="canGoPrevTo"></button>
              <mdc-select value.bind="toMonth" fixed class="mdc-daterange-dialog__month" mdcselect:change.trigger="buildToDays()" outlined.bind="false" natural-width>
                <mdc-list>
                  <mdc-list-item repeat.for="m of months" value.bind="\$index" disabled.bind="m.disabled">\${m.name}
                  </mdc-list-item>
                </mdc-list>
              </mdc-select>
              <span class="mdc-daterange-dialog__nav__spacer"></span>
              <mdc-select value.bind="toYear" fixed class="mdc-daterange-dialog__year" mdcselect:change.trigger="buildToDays()" outlined.bind="false" natural-width>
                <mdc-list>
                  <mdc-list-item repeat.for="y of years" value.bind="y">\${y}</mdc-list-item>
                </mdc-list>
              </mdc-select>
              <button mdc-icon-button icon="keyboard_arrow_right" click.trigger="nextTo()" disabled.bind="canGoNextTo"></button>
            </div>
            <div class="mdc-daterange-dialog__view">
              <span repeat.for="wd of weekDays" class="mdc-daterange-dialog__week-day">\${wd[0]}</span>
              <div repeat.for="d of toDays" class="mdc-daterange-dialog__day \${d.selectedFrom ? 'mdc-daterange-dialog__day--selected-from' : ''} \${d.selectedTo ? 'mdc-daterange-dialog__day--selected-to' : ''} \${d.hovered ? 'mdc-daterange-dialog__day--hovered' : ''} \${d.inRange ? 'mdc-daterange-dialog__day--in-range' : ''} \${d.disabled ? 'mdc-daterange-dialog__day--disabled' : ''}" mouseleave.trigger="handleMouseLeave()">
                <a href="#" mdc-ripple="unbounded.bind: true" click.trigger="select(d)" if.bind="d.date && !d.disabled" mouseover.trigger="handleMouseover(d)">
                  <span>\${d.date | date:'d'}</span>
                </a>
                <a if.bind="d.date && d.disabled">
                  <span>\${d.date | date:'d'}</span>
                </a>
                <div class="mdc-daterange-dialog__in-range-indicator mdc-daterange-dialog__in-range-indicator--\${d.selectedFrom ? 'from' : ''}\${d.selectedTo ? 'to' : ''}">
                </div>
                <svg class="mdc-daterange-dialog__hover-border">
                  <line x1="0" y1="10%" x2="100%" y2="10%"></line>
                  <line x1="0" y1="90%" x2="100%" y2="90%"></line>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <mdc-dialog-actions>
          <button mdc-button outlined click.trigger="clear()">Clear</button>
          <div class="mdc-dialog__action-spacer">Period: \${numberOfDays} days</div>
          <button mdc-button outlined data-mdc-dialog-action="cancel">\${options.i18n.cancel}</button>
          <button mdc-button raised click.trigger="ok()" data-mdc-dialog-initial-focus data-mdc-dialog-button-default>\${options.i18n.ok}</button>
        </mdc-dialog-actions>
      </div>
    </div>
  </mdc-dialog>
</template>
`;
// Exports
export default code;